import React from 'react';
import type { BoxProps } from '@withjoy/joykit';
import { Avatar } from '@withjoy/joykit';
import { useIdentityWidget } from './useIdentityWidget';
import type { IdentityWidgetProps } from './IdentityWidget.types';
import { IdentityWidgetContent } from './components/IdentityWidgetContent';
import { ReactComponent as IconOptionSelectDown } from '@assets/icons/icon-option-select-down.svg';
import { StyledPopover, StyledPillContainer, styles } from './IdentityWidget.styles';

export const IdentityWidget = ({ anchorProps, tabIndex, ...restProps }: IdentityWidgetProps & { anchorProps?: BoxProps; tabIndex: number }) => {
  const { isOpen, setIsOpen, popoverContentRef, openHandler, pillContainerRef } = useIdentityWidget();

  return (
    <StyledPopover
      contentWrapperProps={{ zIndex: 'dropdown' }}
      showArrow={false}
      isOpen={isOpen}
      onInteraction={nextIsOpen => {
        setIsOpen(nextIsOpen);
      }}
      position="bottom-right"
      wrapperTagName="div"
      targetTagName="div"
      transitionElProps={styles.popoverTransitionElProps}
      contentProps={{ ...styles.popoverContentProps, ref: popoverContentRef }}
    >
      <StyledPillContainer
        onKeyDown={(e: React.KeyboardEvent) => openHandler(e)}
        tabIndex={tabIndex}
        $isWidgetOpen={isOpen}
        {...anchorProps}
        ref={pillContainerRef}
        __css={styles.pillContainer}
      >
        <Avatar
          size="md"
          name={{ firstName: restProps.profile.firstName ?? undefined, lastName: restProps.profile.lastName ?? undefined }}
          src={restProps.profile.avatar?.url}
          overrides={{ Root: { props: { marginRight: 4 } } }}
        />
        <IconOptionSelectDown />
      </StyledPillContainer>
      <IdentityWidgetContent {...restProps} />
    </StyledPopover>
  );
};
